import type { PermissionCode } from '@/constants'

/**
 * 判断用户权限码集合是否覆盖"所需权限码"。
 * required 缺省或空数组 → 视为无限制（通过）。
 * required 为数组时 → 命中任一即通过（与后端 OR 语义一致）。
 */
export const hasAnyPermission = (
  required: string | string[] | undefined,
  codes: readonly string[]
): boolean => {
  if (!required) return true
  const list = Array.isArray(required) ? required : [required]
  if (list.length === 0) return true
  return list.some((code) => codes.includes(code))
}

/** 兼容 PermissionCode 字面量类型的重载 */
export const hasPermissionCode = (
  required: PermissionCode | PermissionCode[] | undefined,
  codes: readonly string[]
): boolean => hasAnyPermission(required, codes)

/**
 * 递归过滤路由：移除 meta.permission 与用户权限码不匹配的路由及其后代。
 * 与 store/modules/permission.ts 中的实现保持等价；放在 utils 中便于在
 * 非 store 上下文（如路由守卫、组件）复用。
 */
export const filterRoutesByPermission = (
  routes: AppRouteRecordRaw[],
  codes: readonly string[]
): AppRouteRecordRaw[] =>
  routes
    .filter((route) =>
      hasAnyPermission(
        route.meta?.permission as string | string[] | undefined,
        codes
      )
    )
    .map((route) => ({
      ...route,
      children: route.children ? filterRoutesByPermission(route.children, codes) : route.children
    }))